import gql from 'graphql-tag';

import { createUseLazyQuery } from 'app/graphql/apolloFactoryHelpers';
import {
  GetTerritoryGroupChildren,
  GetTerritoryGroupChildrenVariables
} from 'app/graphql/generated/graphqlApolloTypes';

export const GET_TERRITORY_GROUP_CHILDREN = gql`
  query GetTerritoryGroupChildren($battlecardId: Int!, $territoryGroupParentId: Int!, $startRow: Int!, $endRow: Int!) {
    getTerritoryGroupChildren(
      battlecardId: $battlecardId
      territoryGroupParentId: $territoryGroupParentId
      startRow: $startRow
      endRow: $endRow
    ) {
      items {
        children {
          battlecardId
          color
          battlecardQuotaComponentId
          hierarchyId
          hierarchyTopId
          path
          precedence
          territoryGroupId
          territoryGroupParentId
          territoryGroupName
        }
        battlecardId
        battlecardQuotaComponentId
        color
        hierarchyId
        hierarchyTopId
        hierarchyType
        path
        territoryGroupId
        precedence
        territoryGroupName
        territoryGroupParentId
      }
      totalCount
    }
  }
`;

export const useGetTerritoryGroupChildrenLazy = createUseLazyQuery<
  GetTerritoryGroupChildren,
  GetTerritoryGroupChildrenVariables
>(GET_TERRITORY_GROUP_CHILDREN);
